import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, forwardRef, Input, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { IInput } from '../../molecules/input/input.interface';
import { IErrors } from '../../molecules/input/errors.interface';
import { InputPostcodeLookUpService } from './input.postcode.lookup.service';
import { IAutoCompleteLookup } from './autocomplete.interface';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputPostcodeLookupSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-postcode-lookup',
    templateUrl: './input.postcode.lookup.component.html',
    styleUrls: ['./input.postcode.lookup.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR,
        InputPostcodeLookUpService
    ]
})

export class InputPostcodeLookupSharedComponent implements OnInit {
    @Input() inputSetup: IInput = {id: 'address', placeholder: 'Type postcode', icon: 'compass-direction'};
    @Input() errors: Array<IErrors> = [];
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value: null | { input: string; latitude: number; longitude: number };
    @Input() types = '(regions)';
    @Input() countries = 'country:UK|country:IE';

    selectedIndex = 0;
    predictions: Array<IAutoCompleteLookup> = [];
    searchTerm$ = new Subject<string>();

    reverseAddress = '';
    onChange: any = () => {};
    onTouched: any = () => {};

    constructor(private InputAddLookUpService: InputPostcodeLookUpService) {}

    get value(): any { return this._value; }

    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    ngOnInit(): void {
        this.searchTerm$.subscribe(text => {
            if (text === '') {
                this.closeDropDown();
                // tslint:disable-next-line:no-null-keyword
                this.value = null;
            }

            if (text !== '') {
                this.value = text;
            }
        });

        this.InputAddLookUpService.getAutoComplete(this.searchTerm$, this.types, this.countries)
            .subscribe(results => this.predictions = results);
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    writeValue(value): void {
        if (value && value.input) {
            this.reverseAddress = value.input;
        }
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    setFromSuggestion(value: IAutoCompleteLookup): void {
        this.reverseAddress = value.structured_formatting.main_text;
        this.selectedIndex = 0;

        this.InputAddLookUpService.getLatLongFromPlaceId(value.place_id).subscribe(data => {
            this.value = { ...data, input: this.reverseAddress };
            this.resetErrors();
        });
    }

    closeDropDown(): void {
        this.predictions = [];
    }

    onEnter(): void {
        this.resetErrors();

        // if arrow keys are not used
        if (this.selectedIndex === 0) {
            if (this.reverseAddress) {
                this.InputAddLookUpService.getFirstAutoComplete(this.reverseAddress, this.types, this.countries).subscribe(data => {
                    data ? this.value = { ...data, input: this.reverseAddress } : this.showError();
                });
            } else {
                // tslint:disable-next-line:no-null-keyword
                this.value = null;
            }
        } else {
            this.predictions.forEach((item, index) => {
                if (this.selectedIndex === index + 1) {
                    this.setFromSuggestion(item);
                }
            });
        }
        this.closeDropDown();
        this.selectedIndex = 0;
    }

    arrowUp(): void {
        if (this.predictions.length > 0 && this.selectedIndex > 0) {
            this.selectedIndex--;
        }
    }

    arrowDown(): void {
        if (this.predictions.length > 0) {
            this.selectedIndex++;
        }
    }

    onBlurMethod(): void {
        console.log('blur');
    }

    private resetErrors(): void {
        this.errors = [];
    }

    private showError(): void {
        this.errors = [({title: 'Invalid Postcode'})];
    }
}
